import { IonButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/react';
import { useEffect, useState } from 'react';

import { syncTimer } from '../../../common/interval';
import { ITransactionLog } from '../../../models/log.model';
import store from '../../../store';
import { useAppDispatch } from '../../../store/hooks';
import { clearTransactionLogStoreAsync, selectTransactionLog } from '../../../store/logSlice';
import { IonPageWrapper } from './DebugLogPage.styles';

interface IComponentProps {}

const DebugLogPage: React.FC<IComponentProps> = () => {
  const [transactionLog, setTransactionLog] = useState<ITransactionLog[]>([]);

  const dispatch = useAppDispatch();

  const handleClearLogClick = () => {
    dispatch(clearTransactionLogStoreAsync());
  };

  useEffect(() => {
    const getLog = async () => {
      const log = await selectTransactionLog(store.getState());
      setTransactionLog(log);
    };

    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        getLog();
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPageWrapper>
      <IonHeader color="lightest">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton color="secondary" />
          </IonButtons>
          <IonTitle>Debug Log</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => handleClearLogClick()}>Clear</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent color="lightest">
        <div className="log">
          {' '}
          {transactionLog.map((log) => {
            return (
              <div key={log.id} className="log-item">
                <div>{log.dt}</div>
                <div>
                  [{log.typ.toString().toUpperCase()}] {log.msg}
                </div>
              </div>
            );
          })}
        </div>
      </IonContent>
    </IonPageWrapper>
  );
};

export default DebugLogPage;
